import React from 'react'
import { NavLink, useLocation } from 'react-router-dom'

/**
 * Общий переключатель раздела «Финансы»: одна и та же полоса стоит в шапке
 * «Денег», «Платежей» и «Биллинга», поэтому три страницы читаются как один раздел.
 */
const FINANCE_LINKS = [
    { to: '/admin/money', label: 'Деньги' },
    { to: '/admin/payments', label: 'Платежи' },
    { to: '/admin/billing', label: 'Биллинг и промокоды' },
]

const AdminFinanceNav = ({ className = '' }) => {
    const location = useLocation()

    return (
        <nav
            className={['admin-finance-nav', className].filter(Boolean).join(' ')}
            aria-label="Разделы финансов"
        >
            {FINANCE_LINKS.map((item) => {
                const isActive = location.pathname === item.to || location.pathname.startsWith(`${item.to}/`)

                return (
                    <NavLink
                        key={item.to}
                        to={item.to}
                        className={isActive ? 'admin-finance-nav__item is-active' : 'admin-finance-nav__item'}
                        aria-current={isActive ? 'page' : undefined}
                    >
                        {item.label}
                    </NavLink>
                )
            })}
        </nav>
    )
}

export default AdminFinanceNav
